import React from 'react';
import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
} from 'components/ui/dialog';
import { Input } from 'components/ui/input';
import { Label } from 'components/ui/label';
import { Icon } from 'components/ui/icon';
import { useForm } from 'react-hook-form';
import { VIRTUAL_TERMINAL } from 'state/virtualTerminal/type';
import ErrorMessage from 'components/errorMessage';
import useOrganisation from 'state/organisation/hooks/useOrganisation';

export enum ModalType {
  EDIT = 'edit',
  ADD = 'add',
}
interface IProps {
  modal: boolean;
  setModal: (show: boolean, type?: ModalType) => void;
  type: ModalType;
  onSubmit: (arg: VIRTUAL_TERMINAL.IAddLocationRequest) => void;
  selectedLocation: VIRTUAL_TERMINAL.ILocation | null;
}

const AddLocation = (props: IProps): JSX.Element => {
  const { modal, setModal, type, onSubmit, selectedLocation } = props;
  const { organisation } = useOrganisation();
  const { activeOrg } = organisation;

  const { register, formState, getValues } =
    useForm<VIRTUAL_TERMINAL.ILocation>({
      defaultValues: { name: selectedLocation?.name, id: selectedLocation?.id },
    });

  const onFormSubmit = () => {
    const values = getValues();
    onSubmit({
      ...(selectedLocation || {}),
      name: values.name,
      entity_id: activeOrg?.treez_entity_id || '',
    });
  };

  return (
    <Dialog open={modal} onOpenChange={(open) => !open && setModal(false)}>
      <DialogContent data-testid="edit-location-modal" className="max-w-md">
        <div className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-blue-90">
            {type === ModalType.ADD ? 'Add a new location' : 'Edit location'}
          </h2>

          {type === ModalType.EDIT && (
            <div className="space-y-2">
              <Label htmlFor="id" className="text-sm font-semibold text-gray-blue-80">
                Location ID
              </Label>
              <Input id="id" disabled {...register('id')} />
            </div>
          )}

          <div className="space-y-2">
            <Label htmlFor="name" className="text-sm font-semibold text-gray-blue-80">
              Name of location
            </Label>
            <Input
              id="name"
              {...register('name', { required: 'This is a required field.' })}
            />
            {formState.errors?.name && (
              <ErrorMessage
                isValidation
                message="Please enter location name."
                preIcon={
                  <Icon name="alert-circle" size={16} className="text-danger mr-0.5" />
                }
              />
            )}
          </div>
        </div>

        <DialogFooter className="flex gap-2">
          <Button variant="outline" onClick={() => setModal(false)}>
            Cancel
          </Button>
          <Button
            data-testid="editLocationCTA"
            onClick={onFormSubmit}
            disabled={!formState.isDirty}
          >
            {type === ModalType.ADD ? 'Add' : 'Edit'} location
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddLocation;
